import { Injectable } from '@angular/core';

import { MapsService } from './maps.service';
import { Observable, Subject, Subscription, of } from 'rxjs';
import { Address, AddressModel } from 'src/app/models/address/address.model';
import { catchError, take, tap } from 'rxjs/operators';

// declare var google: any;
@Injectable({
	providedIn: 'root'
})
export abstract class AddressService {
	protected _customConfig: any = {};
	protected _generalSubscription: Subscription = new Subscription();
	public newAddress$: Subject<Address> = new Subject<Address>();

	constructor(
		protected mapsService: MapsService
	) { }

	protected abstract getAddresses(address: any): Observable<AddressModel[]>;
	protected abstract getAddressesByCoordinates(lat: number, lng: number): Observable<AddressModel[]>;
	protected abstract getAddressesByPlaceId(placeId: string): Observable<AddressModel[]>;

	public getFormattedAddress(customerForm, lookupStates, lookupCountries): string {
		const currentAddressState = lookupStates.find(state => state.id === customerForm.state);
		let formattedAddress = customerForm.street + ', ' + customerForm.city;


		if (currentAddressState != null) {
			formattedAddress = formattedAddress + ', ' + currentAddressState.name + ' ' + customerForm.zipCode;
		}
		else {
			formattedAddress = formattedAddress + ', ' + customerForm.zipCode;
		}

		const country = lookupCountries.find(c => c.id === customerForm.country);
		formattedAddress = formattedAddress + ', ' + country?.name;
		return formattedAddress;
	}

	public use(customConfig: any): void {
		this._customConfig = customConfig;
	}

	public clear(): void {
		this._customConfig = {};
		this._generalSubscription.unsubscribe();
		this._generalSubscription = new Subscription();
	}

	protected getAddressString(correctedAddress: Address, currentStateName: string): string {
		let endString = '';
		endString += correctedAddress.line1;
		endString += this.getCommaSeparatedString(correctedAddress.line1, correctedAddress.city);
		endString += this.getCommaSeparatedString(correctedAddress.city, currentStateName);
		endString += this.getCommaSeparatedString(currentStateName, correctedAddress.zipCode);
		return endString;
	}

	private getCommaSeparatedString(previousValue: string, currentValue: string): string {
		let endString = '';

		if (previousValue) {
			if (currentValue) {
				endString += ', ' + currentValue;
			}
		} else {
			endString += currentValue;
		}

		return endString;
	}

	protected mapAddressModelToAddress(model: AddressModel): Address {
		let address: Address = {
			line1: model.line1,
			line2: model.line2,
			city: model.city,
			stateId: model.stateId,
			stateName: model.stateName,
			stateCode: model.stateCode,
			zipCode: model.zipCode,
			isGeoCodingNeeded: true,
			countryId: model.countryId,
			latitude: model.latitude,
			longitude: model.longitude,
			code2: model.code2
		};

		return address;
	}

	protected mapFormToAddress(formData: any, addressId: number): Address {
		let address: Address = {
			addressId,
			line1: formData.street,
			line2: formData.line2,
			city: formData.city,
			stateId: formData.state,
			zipCode: formData.zipCode,
			isGeoCodingNeeded: true,
			countryId: formData.country,
			latitude: formData.latitude,
			longitude: formData.longitude,
			code2: formData.code2
		};

		return address;
	}
}
